import ScopesAuthorization from 'developer-experience-shared-components/scopes/v3/components/ScopesAuthorization';
import { getFullUrl } from 'hubspot-url-utils';
import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useDetailsPageContext } from '../../context/DetailsPageContext';

// @ts-expect-error untyped dependency
import IFrame from 'ui-addon-iframeable/host/IFrame';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function HubSpotOAuthStep({
  isPreview,
  name,
  oauthQueryParams,
  portalId,
  renderedHeaderIcons,
  onOAuthSuccess
}) {
  const {
    trackInteraction
  } = useDetailsPageContext();
  const incomingOAuthQueryParams = useMemo(() => new URLSearchParams(oauthQueryParams), [oauthQueryParams]);
  const renderedOAuthPreview = useMemo(() => {
    var _incomingOAuthQueryPa;
    const scopesStrings = ((_incomingOAuthQueryPa = incomingOAuthQueryParams.get('scope')) === null || _incomingOAuthQueryPa === void 0 ? void 0 : _incomingOAuthQueryPa.split(' ')) || [];
    // @ts-expect-error Partial ScopeGroups for preview
    const scopes = scopesStrings.map(scopeName => ({
      name: scopeName
    }));
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [renderedHeaderIcons, /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "detailsPage.install.hubSpotStep.header",
          options: {
            name
          }
        })
      }), /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        alignItems: "start",
        justifySelf: "center",
        children: /*#__PURE__*/_jsxs(Tile, {
          marginInline: "800",
          marginBlock: "600",
          children: [/*#__PURE__*/_jsxs(TileSection, {
            children: [/*#__PURE__*/_jsx(Text, {
              as: "h6",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "detailsPage.install.hubSpotStep.subheader"
              })
            }), /*#__PURE__*/_jsx(Flex, {
              flexDirection: "column",
              alignItems: "start",
              justifyContent: "start",
              children: /*#__PURE__*/_jsx(ScopesAuthorization, {
                scopes: scopes
              })
            })]
          }), /*#__PURE__*/_jsx(Tooltip, {
            title: unescapedText('detailsPage.install.hubSpotStep.connectTooltip'),
            children: /*#__PURE__*/_jsx(Button, {
              disabled: true,
              marginBlockEnd: "600",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "detailsPage.install.hubSpotStep.connectApp"
              })
            })
          })]
        })
      })]
    });
  }, [incomingOAuthQueryParams, name, renderedHeaderIcons]);
  if (isPreview) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: renderedOAuthPreview
    });
  }
  return /*#__PURE__*/_jsx(IFrame, {
    src: `${getFullUrl('app')}/oauth/${portalId}/embedded/authorize${oauthQueryParams}`,
    embeddedPassthruProps: {
      allowParentRedirect: true
    },
    onReady: () => {},
    onClose: () => {}
    /*  @ts-expect-error Oct-21-2025, 20:15UTC Please fix it - see https://git.hubteam.com/HubSpot/ui-addon-iframeable/pull/290 for more details  */,
    onMessage: ({
      payload
    }) => {
      if (payload.type === 'OAUTH_SUCCESS') {
        onOAuthSuccess(payload.redirectUri);
        trackInteraction({
          action: 'complete hubspot oauth'
        });
      }
    },
    width: "100%",
    height: "100%",
    use: "default"
  });
}